/*
 HotelTest

 Tresc regulaminu dla hotel-TEST
  
 historia: 
  PM 2021-12-08 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Button, Theme, Typography } from '@material-ui/core';

class HotelTest extends React.Component<WithStyles<typeof styles>, any> {

    render() {
        const { classes } = this.props;
        if (document.title !== 'Regulamin świadczenia usług') {
            document.title = 'Regulamin świadczenia usług';
        }

        return (
            <React.Fragment>
                <Typography variant='h6' align="center"><b>REGULAMIN ŚWIADCZENIA USŁUG DROGĄ ELEKTRONICZNĄ</b></Typography>
                <br />
                
                <Typography variant='h6'><b>HOTEL HUBERTUS RZESZÓW</b></Typography>
                <br />
                <Typography variant='body2' gutterBottom>ul. Mickiewicza 5</Typography>
                <Typography variant='body2' gutterBottom>35-064 Rzeszów</Typography>
                <Typography variant='body2' gutterBottom>NIP: 8133282177</Typography>
                <Typography variant='body2' gutterBottom>REGON: 691682062</Typography>
                <Typography variant='body2' gutterBottom>KRS: 0000123492</Typography>
                <br />
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />

                <br />
                <Typography variant='h6' style={{fontSize: "16px"}} ><b>§1 Postanowienia ogólne</b></Typography>
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Niniejszy regulamin określa zasady świadczenia usług drogą elektroniczną przez Hotel Hubertus Rzeszów, prowadzony przez EUROMID Sp. z o.o. z siedzibą przy ul. Mickiewicza 5, 35-064 Rzeszów, za pośrednictwem strony internetowej: <a href="https://hubertus.rzeszow.pl" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            https://hubertus.rzeszow.pl
                        </Button>
                    </a>  oraz systemu rezerwacyjnego.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Regulamin jest udostępniony nieodpłatnie na stronie internetowej w sposób umożliwiający jego pozyskanie, odtwarzanie i utrwalanie.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Każdy Użytkownik zobowiązany jest do zapoznania się z niniejszym regulaminem przed rozpoczęciem korzystania z usług świadczonych drogą elektroniczną.</Typography></li>  
                </ol>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />


                <br />
                <Typography variant='h6' style={{fontSize: "16px"}} ><b>§2 Definicje</b></Typography>
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom><b>Usługodawca / Obiekt</b>  – Hotel Hubertus Rzeszów, prowadzony przez EUROMID Sp. z o.o. z siedzibą przy ul. Mickiewicza 5, 35-064 Rzeszów.</Typography></li>
                    <li><Typography variant='body2' gutterBottom><b>Użytkownik</b> – osoba fizyczna, osoba prawna lub jednostka organizacyjna nieposiadająca osobowości prawnej, korzystająca z usług świadczonych drogą elektroniczną przez Obiekt.</Typography></li>
                    <li><Typography variant='body2' gutterBottom><b>Usługi elektroniczne</b> – usługi świadczone bez jednoczesnej obecności stron (na odległość), za pomocą systemu teleinformatycznego.</Typography></li>  
                    <li><Typography variant='body2' gutterBottom><b>System rezerwacyjny</b> – system online umożliwiający dokonanie rezerwacji usług hotelowych oferowanych przez Hotel Hubertus Rzeszów.</Typography></li>  
                </ol>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />


                <br />
                <Typography variant='h6' style={{fontSize: "16px"}} ><b>§3 Rodzaj i zakres świadczonych usług drogą elektroniczną</b></Typography>
                <ol type="1">
                    <li>
                        <Typography variant='body2' gutterBottom>Usługodawca świadczy za pośrednictwem strony internetowej następujące usługi:
                            <ul>
                                <li>możliwość przeglądania oferty hotelowej;</li>
                                <li>możliwość kontaktu z Obiektem za pośrednictwem formularza kontaktowego;</li>
                                <li>możliwość dokonania rezerwacji online za pośrednictwem systemu rezerwacyjnego;</li>
                                <li>możliwość zapisania się do newslettera.</li>
                            </ul>
                        </Typography>
                    </li>
                </ol>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />


                <br />
                <Typography variant='h6' style={{fontSize: "16px"}} ><b>§4 Warunki świadczenia usług</b></Typography>
                <ol type="1">
                    <li>
                        <Typography variant='body2' gutterBottom>W celu prawidłowego korzystania z usług świadczonych drogą elektroniczną, <br/>Użytkownik powinien posiadać:
                            <ul>
                                <li>urządzenie z dostępem do Internetu;</li>
                                <li>przeglądarkę internetową obsługującą pliki cookies oraz JavaScript;</li>
                                <li>aktywne konto e-mail (dla usług wymagających kontaktu).</li>
                            </ul>
                        </Typography>
                    </li>
                    <li><Typography variant='body2' gutterBottom>Korzystanie z usług jest dobrowolne.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Zakazuje się dostarczania przez Użytkownika treści o charakterze bezprawnym.</Typography></li>  
                </ol>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />


                <br />
                <Typography variant='h6' style={{fontSize: "16px"}} ><b>§5 Warunki zawierania i rozwiązywania umów o świadczenie usług drogą elektroniczną</b></Typography>
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Rozpoczęcie korzystania z usług elektronicznych oznacza zawarcie umowy o świadczenie usług drogą elektroniczną z Usługodawcą.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Umowa o świadczenie usług ulega rozwiązaniu z chwilą zakończenia korzystania z danej usługi.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Użytkownik może w każdej chwili zakończyć korzystanie z usług, opuszczając stronę internetową lub rezygnując z rezerwacji/newslettera.</Typography></li>  
                </ol>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />


                <br />
                <Typography variant='h6' style={{fontSize: "16px"}} ><b>§6 Rezerwacja usług hotelowych</b></Typography>
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Rezerwacji można dokonywać za pośrednictwem systemu rezerwacyjnego dostępnego na stronie internetowej Obiektu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Rezerwacja staje się skuteczna po jej potwierdzeniu przez Hotel Hubertus Rzeszów.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Szczegółowe warunki dotyczące anulacji, płatności i zwrotów dostępne są w zakładce „Warunki rezerwacji”.</Typography></li>  
                </ol>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />


                <br />
                <Typography variant='h6' style={{fontSize: "16px"}} ><b>§7 Ochrona danych osobowych</b></Typography>
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Administratorem danych osobowych jest EUROMID Sp. z o.o.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Dane osobowe Użytkowników przetwarzane są zgodnie z obowiązującymi przepisami prawa, w tym z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 (RODO).</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Szczegółowe informacje na temat przetwarzania danych osobowych zawarte są w Polityce Prywatności dostępnej na stronie internetowej <a href="https://hubertus.rzeszow.pl" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            https://hubertus.rzeszow.pl
                        </Button>
                    </a>.</Typography></li>  
                </ol>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />


                <br />
                <Typography variant='h6' style={{fontSize: "16px"}} ><b>§8 Reklamacje</b></Typography>
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Użytkownik ma prawo składać reklamacje dotyczące usług świadczonych drogą elektroniczną.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Reklamacje należy kierować drogą elektroniczną na adres e-mail: <a href={`mailto:${'recepcja@hubertus.rzeszow.pl'}`} target='_blank' className={`${classes.email}`}>{'recepcja@hubertus.rzeszow.pl'}</a>  lub pisemnie na adres siedziby Usługodawcy.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Reklamacje rozpatrywane są w terminie 14 dni roboczych od dnia ich otrzymania.</Typography></li>  
                </ol>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />
            

                <br />
                <Typography variant='h6' style={{ fontSize: "16px" }} ><b>§9 Postanowienia końcowe</b></Typography>
                <ol type="1">
                    <li>
                        <Typography variant='body2' gutterBottom>W sprawach nieuregulowanych w niniejszym regulaminie mają zastosowanie przepisy prawa polskiego, w szczególności:
                            <ul>
                                <li>ustawy z dnia 18 lipca 2002 r. o świadczeniu usług drogą elektroniczną,</li>
                                <li>ustawy z dnia 30 maja 2014 r. o prawach konsumenta,</li>
                                <li>RODO.</li>
                            </ul>
                        </Typography>
                    </li>
                    <li><Typography variant='body2' gutterBottom>Usługodawca zastrzega sobie prawo do zmiany niniejszego regulaminu. Zmiany wchodzą w życie z chwilą ich opublikowania na stronie internetowej.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Korzystanie przez Użytkownika z usług po zmianie regulaminu oznacza jego akceptację.</Typography></li>
                </ol>
                <br />
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />

            </React.Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    listItem: {
        display: 'list-item',
        marginLeft: theme.spacing(5),
    },
    listNone: {
        listStyleType: 'none'
    },
    breakSpaces: {
        whiteSpace: 'break-spaces' as 'break-spaces'
    },
    linkButton: {
        color: '#3a87ad',
        "&:hover": {
            textDecoration: "underline"
        }
    },
    h6Button: {
        padding: 0,
        fontSize: theme.typography.h6.fontSize,
        lineHeight: theme.typography.h6.lineHeight,
        letterSpacing: theme.typography.h6.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    body2Button: {
        padding: 0,
        fontSize: theme.typography.body2.fontSize,
        lineHeight: '16px',
        letterSpacing: theme.typography.body2.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    link: {
        textDecoration: 'none',
        lineBreak: 'anywhere' as 'anywhere'
    },
    alignCenter: {
        display: 'block',
        textAlign: 'center' as 'center'
    },
    bottomLabelFont: {
        fontSize: '16',
    },
    email: {
        //color: "inherit",
        color: '#3a87ad',
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    },
});

export default withStyles(styles)(HotelTest);
